import { proxy } from 'valtio';

const state = proxy<{
    mode: 'edit' | 'navigate' | 'comment' | 'add-group' | 'add-textarea';
}>({
    mode: 'edit',
});

export { state };
